export default (apiBase, authToken, photoId) => {
    return `${apiBase}/uploads/${photoId}?token=${authToken}`;
};
